import type React from 'react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { completeProfile } from '@/lib/org-api-client'
import { Button } from '@knownow/ui'

export function OnboardingProfilePage(): React.ReactElement {
  const [displayName, setDisplayName] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const handleSubmit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault()
    setError(null)
    setLoading(true)

    try {
      await completeProfile(displayName)
      navigate('/onboarding/org')
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to update profile')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-neutral-50" data-testid="onboarding-profile">
      <div className="w-full max-w-sm space-y-6 rounded-lg bg-white p-8 shadow-md">
        <h1 className="text-display-sm font-serif text-center">Complete your profile</h1>
        <p className="text-sm text-neutral-500 text-center">Tell us a bit about yourself</p>

        {error && (
          <div className="rounded-md bg-error-50 p-3 text-sm text-error-700">{error}</div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="displayName" className="text-sm font-medium text-neutral-700">Display name</label>
            <input
              id="displayName"
              type="text"
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
              required
              className="mt-1 block w-full rounded-md border border-neutral-300 px-3 py-2 text-sm"
              data-testid="display-name-input"
            />
          </div>
          <Button type="submit" disabled={loading} data-testid="profile-submit">
            {loading ? 'Saving...' : 'Continue'}
          </Button>
        </form>
      </div>
    </div>
  )
}
